import Navbar from "./Pages/Navbar/Navbar";
import Home from "./Pages/HomeInside/Home/Home";
import Footer from "./Pages/Footer/Footer";
import Receipes from "./Pages/ReceipeInside/Receipes/Receipes";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/receipes" element={<Receipes />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
